import httpService from '@/utils/request'
import { contextPath } from '@/config/'
export const querySubjectListApi = (params) => {
  return httpService({
    url: contextPath + '/subject/info',
    method: 'get',
    params
  })
}

export const addSubjectItemApi = (data) => {
  return httpService({
    url: contextPath + '/subject/item',
    method: 'post',
    data
  })
}

export const deleteSubjectItemApi = (params) => {
  return httpService({
    url: contextPath + '/subject/item',
    method: 'delete',
    params
  })
}

export const updateSubjectItemApi = (data) => {
  return httpService({
    url: contextPath + '/subject/item',
    method: 'put',
    data
  })
}
